module.exports = __webpack_public_path__ + "static/media/Agility.293082ce.svg";